import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from '../ui/Button';
export function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
      setMobileMenuOpen(false);
    }
  };
  // Detect which page we're on based on the URL path
  const isBookACallPage = window.location.pathname.includes('heylloyd-book-a-call');
  const isWebinarReplyPage = window.location.pathname.includes('webinar-reply');
  // Navigation items based on page type
  const navItems = isBookACallPage ? [{
    label: 'Inicio',
    id: 'hero'
  }, {
    label: 'Beneficios',
    id: 'beneficios'
  }, {
    label: 'Proceso',
    id: 'proceso'
  }, {
    label: 'Resultados',
    id: 'resultados'
  }] : isWebinarReplyPage ? [{
    label: 'Inicio',
    id: 'hero'
  }, {
    label: 'Sistema',
    id: 'paso-1'
  }, {
    label: 'HeyLloyd',
    id: 'paso-2'
  }, {
    label: 'Custom Lloyds',
    id: 'paso-3'
  }, {
    label: 'Galería',
    id: 'gallery'
  }] : [{
    label: 'Inicio',
    id: 'hero'
  }, {
    label: 'Instalación',
    id: 'paso-1'
  }, {
    label: 'Cómo usar',
    id: 'paso-2'
  }, {
    label: 'Custom Lloyds',
    id: 'paso-3'
  }, {
    label: 'Galería',
    id: 'gallery'
  }];
  return <header className="fixed top-0 left-0 right-0 z-50" data-id="element-281" data-mp="3pm364vxt0djn">
      {/* Breaking News Ticker */}
      <div className="bg-red-600 overflow-hidden whitespace-nowrap" data-id="element-282" data-mp="3ujl985p53yjq">
        <div className="inline-block animate-marquee py-1.5 text-white text-xs md:text-sm font-bold tracking-wide" data-id="element-283" data-mp="3g6byeinsgor">
          <span className="mx-8" data-id="element-284" data-mp="8dpp1b3menf4">
            🔥 OFERTA ESPECIAL ÚNICA — Valor{' '}
            <span className="line-through" data-id="element-285" data-mp="257jfaz4zagip">$776</span> → HOY GRATIS 🔥
          </span>
          <span className="mx-8" data-id="element-286" data-mp="2a4t2s98t4i3w">
            🔥 OFERTA ESPECIAL ÚNICA — Valor{' '}
            <span className="line-through" data-id="element-287" data-mp="224da5rp6m5ft">$776</span> → HOY GRATIS 🔥
          </span>
          <span className="mx-8" data-id="element-288" data-mp="1x5tpdumbqzp1">
            🔥 OFERTA ESPECIAL ÚNICA — Valor{' '}
            <span className="line-through" data-id="element-289" data-mp="1x86d6oerk4a0">$776</span> → HOY GRATIS 🔥
          </span>
          <span className="mx-8" data-id="element-290" data-mp="2c0ztud5ruqg9">
            🔥 OFERTA ESPECIAL ÚNICA — Valor{' '}
            <span className="line-through" data-id="element-291" data-mp="272eush29acte">$776</span> → HOY GRATIS 🔥
          </span>
        </div>
      </div>
      <div className="bg-slate-900 border-b border-slate-800" data-id="element-292" data-mp="2l1y2x9v2ho5p">
        <div className="container mx-auto px-4" data-id="element-293" data-mp="2g3mr4tl7p3ku">
          <div className="flex items-center justify-between h-14 md:h-16" data-id="element-294" data-mp="2g2tr0bgrdcbo">
            {/* Logo */}
            <button onClick={() => scrollToSection('hero')} className="flex items-center focus:outline-none focus:ring-2 focus:ring-cyan-500 rounded-lg" data-id="element-295" data-mp="2uvesu2s32j43">
              <img src="https://cdn.magicpatterns.com/uploads/adHaJFewYh1GEUG7kQr7LC/Heylloyd_white.svg" alt="HeyLloyd" className="h-7 md:h-8 w-auto" data-id="element-296" data-mp="33v1xcxg4051d" />
            </button>

            {/* Desktop Navigation */}
            <nav className="hidden md:flex items-center space-x-6 lg:space-x-8" data-id="element-297" data-mp="3ihh1ew6jriuo">
              {navItems.map(item => <button key={item.id} onClick={() => scrollToSection(item.id)} className="text-gray-200 hover:text-cyan-400 transition-colors text-sm font-medium" data-id="element-298" data-mp="3nfinzr36m0aw">
                  {item.label}
                </button>)}
              <a href="https://app.heylloyd.io/web-checkout" target="_blank" rel="noopener noreferrer" data-id="element-299" data-mp="3eh6y5ra536ji">
                <Button variant="cyan" size="sm" data-id="element-300" data-mp="2zomwyw6jv94p">
                  Descargar
                </Button>
              </a>
            </nav>

            {/* Mobile Menu Button */}
            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="md:hidden text-white p-2 hover:bg-slate-800 rounded-lg transition-colors" aria-label={mobileMenuOpen ? 'Cerrar menú' : 'Abrir menú'} data-id="element-301" data-mp="2qrmch0mlpv6j">
              {mobileMenuOpen ? <X className="w-6 h-6" data-id="element-302" data-mp="2lqf5v4w7321g" /> : <Menu className="w-6 h-6" data-id="element-303" data-mp="2lqyflyboyk4e" />}
            </button>
          </div>

          {/* Mobile Navigation */}
          {mobileMenuOpen && <nav className="md:hidden py-3 border-t border-slate-800" data-id="element-304" data-mp="3o3bcw4vlfhtb">
              <div className="flex flex-col space-y-1" data-id="element-305" data-mp="3k3kfvjfh45gc">
                {navItems.map(item => <button key={item.id} onClick={() => scrollToSection(item.id)} className="text-gray-100 hover:text-cyan-400 transition-colors text-left py-2.5 px-4 hover:bg-slate-800 rounded-lg text-base font-medium" data-id="element-306" data-mp="3fb9d88tcm5k3">
                    {item.label}
                  </button>)}
              </div>
            </nav>}
        </div>
      </div>
    </header>;
}